import { useQuery } from '@tanstack/react-query';
import { getDateFormats } from 'api/dateFormats';
import { dateFormatsKeys } from 'api/queryKeys';

/** Lista formatów daty – prawie statyczna, cache 7 dni. */
const DATE_FORMATS_STALE_MS = 7 * 24 * 60 * 60 * 1000; // 7 dni

export const useDateFormatsQuery = () =>
  useQuery({
    queryKey: dateFormatsKeys.list(),
    queryFn: () => getDateFormats().then((res) => res.data ?? []),
    staleTime: DATE_FORMATS_STALE_MS,
    gcTime: DATE_FORMATS_STALE_MS
  });

